module.exports = __webpack_public_path__ + "img/ce74c4dcde2b5c0fd027b5208e0cc254.adc1b78a.jpeg";